import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'

import { KirjautunutKayttajaService } from '../service/kirjautunut-kayttaja.service'

import { KirjanpitajanRooli } from '@lemon/core-firebase/lemonator/model/kirjanpitaja'

import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'

@Injectable()
export class YllapitoGuard {
  constructor(
    private router: Router,
    private kirjautunutKayttajaService: KirjautunutKayttajaService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      map(kayttajanTiedot => {
        return kayttajanTiedot && kayttajanTiedot.rooli === KirjanpitajanRooli.SUPER
      }),
      tap(authenticated => {
        if (!authenticated) {
          this.router.navigate(['/kirjauduttupois'])
        }
      }),
    )
  }
}
